import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Shield, Headphones, Clock, Globe, Heart } from 'lucide-react';
import appStoreIcons from '../Assets/Buttons.png';
import { CreditCard, Smartphone, DollarSign, Landmark } from 'lucide-react';
import visaLogo from '../Assets/visa.png';
import googlePayLogo from '../Assets/google-pay.png';
import paytmLogo from '../Assets/paytm.png';
import cashLogo from '../Assets/cash-on-delivery.png'
import { Link } from 'react-router-dom';
import logo from "../Assets/footerlogo.e53de59ccd9ef1553485.png"

const Footer = () => {

    
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              {/* <div className="w-10 h-10 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-xl font-bold">🚖</span>
              </div> */}
               <div className="flex items-center">
            <Link to="/" className="text-xl md:text-2xl font-bold text-blue-700">
              <span className="text-orange-500">Urbania</span>NavaCabs
            </Link>
          </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Your trusted partner for safe, reliable, and affordable cab services across the country. 
              Book your ride in seconds and travel with confidence.
            </p>
            
            {/* Trust Badges */}
            <div className="flex flex-wrap gap-4 mb-6">
              <div className="flex items-center gap-2 bg-gray-800 px-3 py-2 rounded-lg">
                <Shield className="w-5 h-5 text-green-400" />
                <span className="text-sm">Safe & Secure</span>
              </div>
              <div className="flex items-center gap-2 bg-gray-800 px-3 py-2 rounded-lg">
                <Headphones className="w-5 h-5 text-cyan-400" />
                <span className="text-sm">24/7 Support</span>
              </div>
            </div>
            
            {/* Social Media */}
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors">Home</a>
              </li>
              <li>
                <a href="/contact" className="text-gray-400 hover:text-cyan-400 transition-colors">Book a Cab</a>
              </li>
              <li>
                <a href="/innova-booking-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">Airport Transfers</a>
              </li>
              <li>
                <a href="/innova-booking-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">Outstation Rides</a>
              </li>
              <li>
                <a href="/innova-booking-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">Local Rides</a>
              </li>
              <li>
                <a href="/innova-booking-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">City Tours</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="/innovahybrid-booking-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">Luxury Cabs</a>
              </li>
              <li>
                <a href="/innova-booking-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">SUV Rentals</a>
              </li>
              <li>
                <a href="/innovahybrid-booking-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">Wedding Cars</a>
              </li>
              <li>
                <a href="/urbania-16-seater-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">Corporate Travel</a>
              </li>
              <li>
                <a href="/urbania-12-seater-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">Event Transportation</a>
              </li>
              <li>
                <a href="/urbania-9-seater-bangalore" className="text-gray-400 hover:text-cyan-400 transition-colors">Monthly Packages</a>
              </li>
            </ul>
          </div>

          {/* Contact & Support */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Headphones className="w-5 h-5 text-cyan-400 mt-0.5" />
                <div>
                  <p className="text-gray-400">24/7 Customer Support</p>
                  <a href="tel:+919916788688" className="font-medium hover:text-cyan-400">+91 99647 58999 </a><br/>
                  <a href="tel:+919964758999" className="font-medium hover:text-cyan-400">+91 99647 58999</a>

                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-cyan-400 mt-0.5" />
                <div>
                  <p className="text-gray-400">Business Hours</p>
                  <p className="font-medium">Mon-Sun: 24/7</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Globe className="w-5 h-5 text-cyan-400 mt-0.5" />
                <div>
                  <p className="text-gray-400">Email</p>
                  <a href="mailto:support@cabbooking.com" className="font-medium hover:text-cyan-400">urbanianavacabs@gmail.com</a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Download App Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div>
              <h3 className="text-lg font-bold mb-2">Download Our App</h3>
              <p className="text-gray-400">Book cabs faster with our mobile app</p>
            </div>
            <div className="flex flex-wrap gap-4">
  <a href="#" className="flex items-center gap-3  hover:bg-gray-700 px-6 py-3 rounded-lg transition-colors">
    <div className="">
      <img 
        src={appStoreIcons} 
        alt="App Store and Google Play" 
        className="w-full h-full object-contain"
      />
    </div>
    {/* <div>
      <p className="text-xs text-gray-400">Download our app</p>
      <p className="font-bold">Available Now</p>
    </div> */}
  </a>
</div>
          </div>
        </div>
      </div>

     {/* Bottom Footer */}
<div className="bg-gray-950 py-6">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
      {/* Copyright - Left */}
      <div className="text-gray-500 text-sm">
        © {new Date().getFullYear()} CabBooking. All rights reserved.
      </div>
      
      {/* Developer Credit - Center */}
      <div className="flex items-center justify-center gap-2">
        <span className="text-gray-500 text-sm">Developed by</span>
        <a 
          href="https://freelancerx.in" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-2 group hover:opacity-80 transition-opacity"
        >
          <span className="text-white font-semibold group-hover:text-cyan-400 transition-colors">
            FreelancerX
          </span>
          
          <img 
            src={logo} 
            alt="FreelancerX Logo" 
            className="w-8 h-8 object-contain bg-gray-200 rounded-full p-1"
          />
        </a>
      </div>

      {/* Right side - You can add payment methods or other content here */}
      <div className="flex items-center gap-2">
        {/* Add your right side content here */}
        {/* For example, if you want to add payment methods back: */}
        {/* 
        <span className="text-gray-400 text-sm">Accepted Payments:</span>
        <img src={visaLogo} alt="Visa" className="w-8 h-6 object-contain bg-white p-1 rounded" />
        <img src={googlePayLogo} alt="Google Pay" className="w-8 h-6 object-contain bg-white p-1 rounded" />
        <img src={paytmLogo} alt="Paytm" className="w-8 h-6 object-contain bg-white p-1 rounded" />
        <img src={cashLogo} alt="Cash" className="w-8 h-6 object-contain bg-white p-1 rounded" />
        */}
      </div>
    </div>
  </div>
</div>
    </footer>
  );
};

export default Footer;